import { create } from 'zustand';

/**
 * Open state for the action-param popover. The composer's slash-command
 * `execute()` callback sets `openFor` to `'translate'` when the user picks
 * the translate action; the popover subscribes and renders the
 * target-language list. The store holds only the open/close signal.
 */

export type ActionParamTarget = 'translate';

interface ActionParamState {
  openFor: ActionParamTarget | null;
  open: (target: ActionParamTarget) => void;
  close: () => void;
}

export const useActionParamStore = create<ActionParamState>((set) => ({
  openFor: null,
  open: (target) => set({ openFor: target }),
  close: () => set({ openFor: null }),
}));
